{
  "pl-PL": {
    "model": {
      "profile": {
        "id": "Identyfikator użytkownika.",
        "userName": "Nazwa użytkownika",
        "email": "Adres e-mail",
        "emailConfirmed": "Adres e-mail został potwierdzony.",
        "phoneNumber": "Numer telefonu",
        "phoneNumberConfirmed": "Numer telefonu potwierdzony.",
        "twoFactorEnabled": "Włączono uwierzytelnianie dwuskładnikowe.",
        "lockoutEnd": "Koniec blokady",
        "lockoutEnabled": "Funkcja blokowania włączona.",
        "accessFailedCount": "Liczba nieudanych prób uzyskania dostępu.",
        "firstName": "Imię",
        "lastName": "Nazwisko",
        "picture": "Zdjęcie profilowe.",
        "organisationName": "Organizacja",
        "name": "Nazwa",
        "roles": "Role"
      }
    },
    "profileManager": {
      "column": {
        "emailConfirmed": "Potwierdzono"
      },
      "action": {
        "resetPassword.tooltip": "Wyślij instrukcje dotyczące resetowania hasła do użytkownika drogą mailową."
      },
      "message": {
        "resetPassword.success": "Na adres e-mail użytkownika została wysłana wiadomość zawierająca instrukcje dotyczące resetowania hasła."
      }
    }
  }
}